import apiClient from "./axiosInstance"

export const TAfindBrand = async (query: any) => {
  const response = await apiClient.get(`/admin/brand/get?${query}`, {})

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error(response.data.message)
  }
}

export const TAfindBrandName = async (data: any) => {
  const response = await apiClient.get(`/admin/brand/brandname?brand_name=${data}`, {})

  if (response.status === 200) {
    return response.data
  }
}

export const TAfindAllBrands = async (
  sortBy: string,
  sortOrder: boolean,
  page: number,
  perPage: number,
  params: any,
  signal?: AbortSignal,
) => {
  const response = await apiClient.get(
    `/admin/brand/getall?page=${page}&perPage=${perPage}&sortBy=${encodeURIComponent(
      sortBy,
    )}&sortOrder=${encodeURIComponent(sortOrder)}&${params}`,
    { signal },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Brands not found")
  }
}

export const TAfindBrandById = async (id: string) => {
  const response = await apiClient.get(`/admin/brand/get/${id}`, {})
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find User failed")
  }
}

export const TAupdateBrand = async (id: string, data: any) => {
  const response = await apiClient.put(`/admin/brand/update/${id}`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TAupdateNote = async (
  id: string,
  author: string,
  note?: string,
  files?: FileList | File[] | Blob[],
  signal?: AbortSignal,
) => {
  const fd = new FormData()
  fd.append("author", author)
  if (note) {
    fd.append("note", note)
  }

  if (files) {
    const arr = files instanceof FileList ? Array.from(files) : (files as (File | Blob)[])
    for (const f of arr) {
      fd.append("files", f)
    }
  }

  const res = await apiClient.put(`/admin/brand/update-note/${id}`, fd, {
    signal,
    headers: { "Content-Type": undefined as any },
  })
  return res.data
}

export const TAdeleteNote = async (id: string, noteIndex: number) => {
  const response = await apiClient.delete(`/admin/brand/delete-note/${id}`, {
    data: { noteIndex },
    headers: {
      "Content-Type": "application/json",
    },
  })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Delete failed")
  }
}

export const TASpamBrand = async (id: string, status: any) => {
  const response = await apiClient.put(`/admin/brand/setspambrand/${id}/${status}`, {})
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find User failed")
  }
}

export const TAupdateBrandLogo = async (id: string, data: any) => {
  const response = await apiClient.put(`/admin/brand/updatebrandlogo/${id}`, data, {
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=<calculated when request is sent></calculated>",
    },
  })
  return response
}

export const TAupdateBrandMeeting = async (id: string, meeting: any, author: string) => {
  const response = await apiClient.put(
    `/admin/brand/update-meeting/${id}`,
    { meeting, author },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TAdeleteBrandMeeting = async (id: string, meetingIndex: number) => {
  const response = await apiClient.put(
    `/admin/brand/delete-meeting/${id}`,
    { meetingIndex },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Delete failed")
  }
}

export const TAupdateBrandStage = async (id: string, stage: any) => {
  const response = await apiClient.put(
    `/admin/brand/stage/${id}`,
    { stage },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TAmeetingPlanned = async (id: string, status: any) => {
  const response = await apiClient.post(
    `/admin/brand/meeting-planned/${id}`,
    { status },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TAinformationMailSent = async (id: string, status: any) => {
  const response = await apiClient.post(
    `/admin/brand/information-mail-sent/${id}`,
    { status },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TAdirectedToAgencyBasedWork = async (id: string, status: any) => {
  const response = await apiClient.post(
    `/admin/brand/directed-to-agency-based-work/${id}`,
    { status },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TAdemoCampaignCreated = async (id: string, status: any) => {
  const response = await apiClient.post(
    `/admin/brand/demo-campaign-created/${id}`,
    { status },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TAbalanceLoaded = async (id: string, status: any) => {
  const response = await apiClient.post(
    `/admin/brand/balance-loaded/${id}`,
    { status },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TAcampaignManagementContinues = async (id: string, status: any) => {
  const response = await apiClient.post(
    `/admin/brand/campaign-management-continues/${id}`,
    { status },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TAcampaignCompleted = async (id: string, status: any) => {
  const response = await apiClient.post(
    `/admin/brand/campaign-completed/${id}`,
    { status },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TApersonalAccount = async (id: string, status: any) => {
  const response = await apiClient.post(
    `/admin/brand/personal-account/${id}`,
    { status },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TAupdateBalance = async (id: string, balance: number, operation: string) => {
  const response = await apiClient.put(
    `/admin/brand/balance/${id}`,
    { balance, operation },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TAgetBrandCampaigns = async (id: string) => {
  const response = await apiClient.get(`/admin/brand/campaigns?id=${id}`, {
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TAbrandSalesReadiness = async (id: string, rate: number) => {
  const response = await apiClient.post(`/admin/brand/sales-readiness/${id}?rate=${rate}`, {
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TAbrandECommerce = async (id: string, ecommerce: string) => {
  const response = await apiClient.post(
    "/admin/brand/ecommerce",
    {
      id,
      ecommerce,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TAbrandHeardFrom = async (id: string, heardFrom: string) => {
  const response = await apiClient.post(
    `/admin/brand/set-heardfrom/${id}`,
    { heardFrom },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TAgetBrandStateStats = async (
  startDate?: string,
  endDate?: string,
  signal?: AbortSignal,
) => {
  const params = new URLSearchParams()
  if (startDate) {
    params.append("startDate", startDate)
  }
  if (endDate) {
    params.append("endDate", endDate)
  }

  const url = `/admin/brand/brand-state${params.toString() ? `?${params.toString()}` : ""}`

  const response = await apiClient.get(url, {
    headers: {
      "Content-Type": "application/json",
    },
    signal,
  })

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Brand state statistics not found")
  }
}

export const TAgetUnregisteredBrands = async (
  sortBy: string,
  sortOrder: boolean,
  page: number,
  perPage: number,
  params: any,
  signal?: AbortSignal,
) => {
  const response = await apiClient.get(
    `/admin/brand/unregistered?page=${page}&perPage=${perPage}&sortBy=${encodeURIComponent(
      sortBy,
    )}&sortOrder=${encodeURIComponent(sortOrder)}&${params}`,
    { signal },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Unregistered brands not found")
  }
}

export const TAsetResponsibleAdmin = async (brandId: string, responsibleAdmins: string[]) => {
  const response = await apiClient.put(`/admin/brand/set-responsible-admin/${brandId}`, {
    responsible_admin: responsibleAdmins,
  })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Responsible admin not found")
  }
}

export const TAgetAdmins = async () => {
  const response = await apiClient.get("/admin/brand/admins")
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Admins not found")
  }
}

export const TAgetBrandFromName = async (names: string[]) => {
  const response = await apiClient.post("/admin/brand/brand-from-name", names)
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Brand not found")
  }
}

export const TAgetCampaignNotes = async (brandId: string) => {
  const response = await apiClient.get(`/admin/brand/campaign-notes?brandId=${brandId}`)
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Campaign notes not found")
  }
}

export const TAbrandSize = async (brandId: string, size: string) => {
  const response = await apiClient.put(
    "/admin/brand/brand-size",
    {
      brandId,
      size,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TAgetBrandFromIds = async (brandIds: string[]) => {
  const response = await apiClient.post("/admin/brand/brand-from-ids", { brandIds })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Brands not found")
  }
}

export const TAgetBrandStateDurationStats = async (
  startDate?: string,
  endDate?: string,
  signal?: AbortSignal,
  period: "daily" | "weekly" | "monthly" = "monthly",
) => {
  const params = new URLSearchParams()
  if (startDate) {
    params.append("startDate", startDate)
  }
  if (endDate) {
    params.append("endDate", endDate)
  }
  if (period) {
    params.append("period", period)
  }

  const url = `/admin/brand/brand-state-stats${params.toString() ? `?${params.toString()}` : ""}`

  const response = await apiClient.get(url, {
    headers: {
      "Content-Type": "application/json",
    },
    signal,
  })

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Brand state duration statistics not found")
  }
}

export const TAbrandSetCpmAim = async (brandId: string, cpmAim: number) => {
  const response = await apiClient.put(
    "/admin/brand/brand-cpm-aim",
    {
      brandId,
      cpmAim,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TAbrandSetLeadStyle = async (brandId: string, leadStyle: string) => {
  const response = await apiClient.put(
    "/admin/brand/brand-lead-style",
    {
      brandId,
      leadStyle,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TAbrandSetUtm = async (
  brandId: string,
  utm: { utm_source?: string; utm_medium?: string; utm_campaign?: string },
) => {
  const response = await apiClient.put(
    "/admin/brand/set-utm",
    {
      brandId,
      utm,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TAgetNewRegisters = async (dateStart: string, dateEnd: string) => {
  const response = await apiClient.get(
    `/admin/brand/new-registers?dateStart=${dateStart}&dateEnd=${dateEnd}`,
    {
      timeout: 60000,
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("New registrations data not found")
  }
}

export const TAredirectBrandAccount = async (id: string) => {
  const response = await apiClient.get(`/admin/brand/redirect-brand-account/${id}`, {
    timeout: 60000,
  })

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("New registrations data not found")
  }
}

export const TAbrandReferenceChange = async (id: string, reference: string) => {
  const response = await apiClient.post(
    `/admin/brand/reference-change/${id}`,
    { reference },
    {
      timeout: 60000,
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("New registrations data not found")
  }
}

export const TAsetBrandClassification = async (
  brandId: string,
  main_category: string,
  sub_categories: { name: string; confidence: number }[],
) => {
  const response = await apiClient.post(
    "/admin/brand/set-classification",
    {
      brandId,
      main_category,
      sub_categories,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update classification failed")
  }
}

/**
 * AI-Powered Brand Health Analysis
 * Customer Success için marka sağlık analizi
 * 
 * @param brandId - Marka ID
 * @param refresh - true ise yeni analiz yapar, false ise cache kullanır
 */
export const TAgetBrandAIHealthAnalysis = async (brandId: string, refresh = false) => {
  const response = await apiClient.get(
    `/admin/brand/ai-health-analysis/${brandId}?refresh=${refresh}`,
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("AI Health Analysis failed")
  }
}
